import React from 'react'
import { Box, Card, CardContent, Heading, Text } from '../components/ui'
import PageHero from '../components/PageHero'
import { Breadcrumbs } from '../components/Breadcrumbs'
import './Contact.css'

const Contact: React.FC = () => {
  return (
    <Box 
      className="page contact-page premium-page-bg"
      style={{
        minHeight: '100vh',
      }}
    >
      <Box className="container premium-page-container">
        {/* Breadcrumbs */}
        <Breadcrumbs items={[
          { label: 'Strona główna', path: '/' },
          { label: 'Kontakt' }
        ]} />

        <PageHero 
          badge="KONTAKT"
          title="Kontakt"
          subtitle="Dane kontaktowe platformy wojskaspecjalne.pl"
        />

        {/* Main Contact Info */}
        <Box className="contact-grid">
          {/* EPKO Info Card */}
          <Card size="4" className="contact-card fade-in-up">
            <CardContent>
              <Heading as="h2" size="6" className="contact-card-title">
                EPKO
              </Heading>
              <Text className="contact-card-description" size="3">
                Organizacja odpowiedzialna za hosting, utrzymanie oraz rozwój infrastruktury technicznej platformy wojskaspecjalne.pl
              </Text>
              
              <Box className="contact-info-block">
                <Text weight="bold" size="3" className="contact-label">
                  Osoba odpowiedzialna:
                </Text>
                <Text size="3" className="contact-value">
                  Patryk Korzeniowski
                </Text>
                <Text size="2" className="contact-note">
                  Bezpośrednie zarządzanie platformą w ramach organizacji EPKO
                </Text>
              </Box>
            </CardContent>
          </Card>

          {/* Email Card */}
          <Card size="4" className="contact-card fade-in-up stagger-1">
            <CardContent>
              <Heading as="h2" size="5" className="contact-card-title">
                Kontakt mailowy
              </Heading>
              <Text className="contact-card-description" size="3">
                Standardowy czas odpowiedzi: 24-48 godzin roboczych
              </Text>
              <a 
                href="mailto:patryk.korzeniowski@epko.tech" 
                className="contact-link"
              >
                patryk.korzeniowski@epko.tech
              </a>
            </CardContent>
          </Card>

          {/* Support Card */}
          <Card size="4" className="contact-card fade-in-up stagger-2">
            <CardContent>
              <Heading as="h2" size="5" className="contact-card-title">
                Forum społeczności
              </Heading>
              <Text className="contact-card-description" size="3">
                Publiczne dyskusje, wymiana wiedzy oraz wsparcie społeczności użytkowników
              </Text>
              <a 
                href="/forum" 
                className="contact-link"
              >
                Przejdź do Forum →
              </a>
            </CardContent>
          </Card>
        </Box>

        {/* About Section */}
        <Box className="contact-about">
          <Heading as="h2" size="6" className="contact-about-title">
            O Projekcie
          </Heading>
          <Text className="contact-about-text" size="3">
            Platforma wojskaspecjalne.pl jest projektem non-profit realizowanym przez{' '}
            <a 
              href="https://epko.tech" 
              target="_blank" 
              rel="noopener noreferrer"
              className="contact-about-link"
            >
              EPKO Tech
            </a>
            . Organizacja odpowiada za hosting, utrzymanie oraz rozwój platformy edukacyjnej.
            W sprawach technicznych i operacyjnych prosimy o kontakt z Patrykiem Korzeniowskim.
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default Contact

